import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

export interface SalesSessionContext {
    waiterId: string;
    locationId: string;
    cashDrawerId: string;
    serviceId: string;
    accountId: string;
}

export interface SalesSessionPort {
    getSessionContext(): Observable<SalesSessionContext>;
}

export const SALES_SESSION_PORT = new InjectionToken<SalesSessionPort>('SALES_SESSION_PORT');
